export default __webpack_public_path__ + "static/media/blog-39-5.c2ce7aa2.png";